/* Hero Tiles — variante B de la prueba Convert "hero-tile".
   Carrusel con scroll-snap nativo: flechas en desktop cuando hay desborde y dots en ≤1140px. */
(() => {
  if (customElements.get('hero-tiles')) return;

  class HeroTiles extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-tiles-track]');
      if (!this.track) return;

      this.tiles = Array.from(this.track.children);
      this.prevButton = this.querySelector('[data-hero-tiles-prev]');
      this.nextButton = this.querySelector('[data-hero-tiles-next]');
      this.dots = Array.from(this.querySelectorAll('[data-hero-tiles-dot]'));

      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroTilesDot)));
      });

      // Mientras Convert no active la variante el elemento mide 0; el observer recalcula al hacerse visible
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    tileOffset(index) {
      const tile = this.tiles[index];
      if (!tile) return 0;
      const paddingLeft = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      return tile.offsetLeft - this.track.offsetLeft - paddingLeft;
    }

    activeIndex() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.track.scrollLeft >= maxScroll - 2) return this.tiles.length - 1;

      let closest = 0;
      let closestDistance = Infinity;
      this.tiles.forEach((_, index) => {
        const distance = Math.abs(this.tileOffset(index) - this.track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      return closest;
    }

    goTo(index) {
      const clamped = Math.max(0, Math.min(index, this.tiles.length - 1));
      this.track.scrollTo({ left: this.tileOffset(clamped), behavior: this.scrollBehavior() });
    }

    step(direction) {
      this.goTo(this.activeIndex() + direction);
    }

    scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = maxScroll > 2;

      if (this.prevButton && this.nextButton) {
        this.prevButton.hidden = !overflowing;
        this.nextButton.hidden = !overflowing;
        this.prevButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
      }

      const active = this.activeIndex();
      this.dots.forEach((dot, index) => {
        const isActive = index === active;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('hero-tiles', HeroTiles);
})();
